export const getFirstParagraph = (longText?: string) => {
  if (!longText) return '';
  //we need to support 2 different ways of editing this info which are slightly different
  const split1: string = longText.split('\\n')[0] ?? '';
  const split2: string = longText.split('\n')[0] ?? '';
  if (!split1 && !split2) return '';
  return split1.length < split2.length ? split1 : split2;
};
